/*=================================================
    summary: 學生作答 組合題 Composition 單元 
             練習 說一說        LUSeqNo: 14             
             練習 寫一寫        LUSeqNo: 18
             練習 小組活動      LUSeqNo: 19
             複習 寫一寫        LUSeqNo: 22
             複習 說一說        LUSeqNo: 23

             Practice Speaking
             Practice Writing Composition
             Practice Activity
             Review Writing Composition
             Review Speaking

             撈資料 與 Header在這邊做

    remarks: 000 Tim 2021/12/30 Create  原Jeff寫的 PracticeSpeaking
             001 Tim 2022/01/14 串接 LanguageChangeHandler 流程
=================================================*/

import React, { useEffect, useState, useRef, useContext } from 'react'
import cssCompositionMain from './CompositionMain.module.scss'

import CompositionContent from '../CompositionContent/CompositionContent';

import { LUCacheContext } from '../../../LearningUnit.js'

import { ExecuteActionEnum, TestSheetModeEnum } from '../CompositionContent/CompositionContent';
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

export const TestSheetContext = React.createContext({});

// #region Constant
const COMP_NAME = "CompositionMain"
// #endregion Constant

// #region Member Variables
let mblnInitialized = false

let mstrLUKey4LUCachedContext = "" // 用於從LUCacheContext 取出 Cache的LU資料時 指出此LU時所需的Key
let mintIndex4HistoryItemToShow = -1
let mstrBookCatID = ""
let mstrLUCatSeqNo = ""

let mobjTestSheet = {
    Mode: 1,    // TestSheetModeEnum.New
    Score: -1,
    Dirty: false,
    AnswerList: [],
    AssignID: -1
}

let mfuncExecuteCompositionContentAction = null
let mfuncLanguageChangeHandler = null
let mblnPracticeEnable = true // 1) 老師設定 Show Practice/Review to Student 決定是否允許學生作答 2）當有允許時 是否有超過最多作答次數 Submission次數的設定可能是 至多1次 至多2次 或 無限多次
let mstrPracticeDisableMessage = "" // 當不允許Practice時 要顯示的訊息
// #endregion Member Variables

function CompositionMain(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [practiceEnable, setPracticeEnable] = useState(true) // 當不允許練習時 要顯示訊息給使用者
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region Init Context Ref
    // History, Temp, 都是 Cached 在這裏
    let mobjLUCacheContext = useContext(LUCacheContext)
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)
    // #endregion Init Context Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)

        mblnInitialized = true
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
        }
    }, [props.LUInfo])
    // #endregion useEffect

    // #region Painted Me
    // 程式進入 
    // 從 Backend 要資料
    // 需要 Open Loading Mask, 所以不要寫在 .Begin, 要寫在 useEffect
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")

        RegisterExecuteCompositionMainAction()
        RegisterLanguageChangeHandler()

        mstrLUKey4LUCachedContext = "LU" + props.LUInfo.LUCatSeqNo // 用於Cache LU資料時 指出此LU的Key
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo

        console.log(COMP_NAME + ".PaintedMe.mstrLUKey4LUCachedContext: ", mstrLUKey4LUCachedContext)
        console.log(COMP_NAME + ".PaintedMe.mstrLUCatSeqNo: ", mstrLUCatSeqNo)

        let objHistoryList = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]
        if ((typeof (objHistoryList) === 'undefined') || (objHistoryList.LessonID !== props.LessonID))
        {
            console.log("need to get Assignment History")
            GetPrerequisiteDataProcessBegin()
        }
        else
        {
            console.log("need Not to get Assignment History")
            GetPrerequisiteDataProcessEnd()
        }
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        mblnInitialized = false
        mstrLUKey4LUCachedContext = ""
        mstrLUCatSeqNo = ""
        mfuncExecuteCompositionContentAction = null
        mfuncLanguageChangeHandler = null       // 這邊離開 會 移除 所以 CompositionContent 不做反註冊  Tim22.01.14
        mobjTestSheet = {
            Mode: TestSheetModeEnum.New,
            Score: -1,
            Dirty: false,
            AnswerList: [],
            AssignID: -1
        }
        mblnPracticeEnable = true
        mstrPracticeDisableMessage = ""
        setUpdateDataTime(0)
    }
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 點選 學生做答 按鈕
    remarks: 000 Tim 2021/12/30 Create
    ===========================================*/
    function SubSubSectionOnTapHandler()
    {
        console.log(COMP_NAME + ".SubSubSectionOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let intLUCatSeqNo = 0
        if (parseInt(mstrLUCatSeqNo) === window.gDCPLUEnum.PracticeWritingComposition)
        {
            // 練習 寫一寫        LUSeqNo: 18
            // GoToLU -> 練習 寫一寫 LUSeqNo: 26
            intLUCatSeqNo = window.gDCPLUEnum.PracticeWritingGrammarExercises
        }
        else if (parseInt(mstrLUCatSeqNo) === window.gDCPLUEnum.ReviewWritingComposition)
        {
            // 複習 寫一寫        LUSeqNo: 22
            // GoToLU -> 複習 寫作  LUSeqNo: 27
            intLUCatSeqNo = window.gDCPLUEnum.ReviewWritingGrammarExercises
        }

        let objCallbackData = {
            "Action": "GoToLU",
            "LUCatSeqNo": intLUCatSeqNo
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    } // end of SubSubSectionOnTapHandler

    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/14 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置
        
        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler

    function HistoryOnTapHandler()
    {
        console.log(COMP_NAME + ".HistoryOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log("mobjLUCacheContext:", mobjLUCacheContext)
        console.log("mstrLUKey4LUCachedContext:", mstrLUKey4LUCachedContext)
        let objCallbackData = {
            "Action": "HistoryWindowOpen",
            "CallbackRef": HistoryWindowCallback,
            "LessonID": props.LessonID,
            "AssigementHistoryList": mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList,
            "AssignmentTempAns": mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext]
        }
        props.CallbackRef(objCallbackData)
    }

    function RetryOnTapHandler()
    {
        console.log(COMP_NAME + ".RetryOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // setCurrentPageIndex(RETRY_PAGE_INDEX)
        window.AudioLibs.StopAudio()

        let intAction = ExecuteActionEnum.Retry
        mfuncExecuteCompositionContentAction(intAction)

        SetTestSheetObject(TestSheetModeEnum.New)

        SetTestSheetContextNotDirtyForLearningUnit()
    }

    function SaveOnTapHandler()
    {
        console.log(COMP_NAME + ".SaveOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        SaveAnswer()
    }

    function SubmitOnTapHandler()
    {
        console.log(COMP_NAME + ".SubmitOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // ExecuteSubmitAnswer()

        let intAction = ExecuteActionEnum.SubmitAnswer
        mfuncExecuteCompositionContentAction(intAction)

        SetTestSheetContextNotDirtyForLearningUnit()
    }
    // #endregion OnTapHandler

    // #region Other Handler
    function SetTestSheetContextNotDirtyForLearningUnit()
    {
        let objCallbackData = {
            "Action": "TestSheetContextNotDirty"
        }
        props.CallbackRef(objCallbackData)
    }

    /*===========================================
    summary: 語言設定 改變 事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function LanguageOnChangeHandler()
    {
        // console.log(COMP_NAME + ".LanguageOnChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".LanguageOnChangeHandler BEGIN")

        // 這一層 本身沒做事

        if (mfuncLanguageChangeHandler !== null)
        {
            mfuncLanguageChangeHandler()
        }
    } // end of LanguageOnChangeHandler
    // #endregion Other Handler

    // #region LoadingMask and Alert
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    }

    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    }
    // #endregion LoadingMask and Alert

    // #region Component Callback

    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/12/29 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "RegisterExecuteCompositionContentAction")
        {
            mfuncExecuteCompositionContentAction = CallbackObj.Function
        }
        else if (CallbackObj.Action === "RegisterLanguageChangeHandler")
        {
            mfuncLanguageChangeHandler = CallbackObj.Function
        }
        else if (CallbackObj.Action === "TestSheetContextDirty")
        {
            setUpdateDataTime(new Date().getTime())
            props.CallbackRef(CallbackObj) // 告訴Learning Unit 為了在使用者直接切換LU時 可以偵測到目前有Dirty
        }
        else if (CallbackObj.Action === "ChangeTestSheetMode")
        {
            if (CallbackObj.TestSheetMode === TestSheetModeEnum.History)
            {
                mintIndex4HistoryItemToShow = 0
            }
            CheckPraceticeEnable()
            SetTestSheetObject(CallbackObj.TestSheetMode)
        }
        else if (CallbackObj.Action === "SaveAnswer")
        {
            SaveAnswer()
        }
        else
        {
            // 其他 事件 直接往上送
            props.CallbackRef(CallbackObj)
        }
    } // end of ComponentCallback

    function HistoryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".HistoryWindowCallback: ", CallbackObj)

        if (CallbackObj.Action === "HistoryWindowDetail")
        {
            console.log("HistoryWindowCallback.DetailOnTap")
            console.log("CallbackObj.AssignmentIndex:", CallbackObj.AssignmentIndex)
            mintIndex4HistoryItemToShow = parseInt(CallbackObj.AssignmentIndex)
            SetTestSheetObject(TestSheetModeEnum.History)
        }
        else if (CallbackObj.Action === "HistoryWindowLastSaved")
        {
            console.log("HistoryWindowCallback.LastSavedOnTap")
            // 點擊 HistoryWindow中的 LastSaved
            SetTestSheetObject(TestSheetModeEnum.Temp)
        }
    }
    // #endregion Component Callback

    // #region Other Functions

    // 判斷是否允許作答
    function CheckPraceticeEnable()
    {
        console.log(COMP_NAME + ".CheckPraceticeEnable")
        let blnEnablePractice = true
        let intAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

        if (intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
        {
            // 學生才會套用限制
            console.log("window.gSession.Acc.Class:", window.gSession.Acc.Class)
            console.log("window.gSession.Acc.CurrentClassIndex:", window.gSession.Acc.CurrentClassIndex)
            console.log("window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]:", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex])
            console.log("IsDCPSectionPracticeShow:", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow)

            console.log("mobjLUCacheContext:", mobjLUCacheContext)
            console.log("mstrLUKey4LUCachedContext:", mstrLUKey4LUCachedContext)
            console.log("mobjLUCacheContext.AssigementHistoryList:", mobjLUCacheContext.AssigementHistoryList)
            console.log("mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])

            let strMsg = ""

            // Show Practice to Student 有允許Practice
            let intAssignCount = 0 // 學生之前已Submit的次數
            if (
                (typeof (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]) !== "undefined") &&
                (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] !== null) &&
                (typeof (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList) !== 'undefined') &&
                (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList !== null) &&
                (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length > 0)
            )
            {
                console.log("mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length:", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length)
                intAssignCount = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length
            }
            console.log("intAssignCount: ", intAssignCount)
            console.log("window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax: ", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax)

            // 學生身份
            if (
                (
                    (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.PracticeSpeaking) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0)
                ) ||
                (
                    (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.PracticeActivity) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0)
                ) ||
                (
                    (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.PracticeWritingComposition) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0)
                ) ||
                (
                    (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.ReviewSpeaking) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionHWShow) === 0)
                ) ||
                (
                    (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.ReviewWritingComposition) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionHWShow) === 0)
                )
            )
            {
                // 老師關閉 Practice 或 Review
                strMsg = window.gAppUI.MSG_Alert_Msg_BlockedInstructor
                blnEnablePractice = false
            }
            else if (
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= 2) &&
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= intAssignCount)
            )
            {
                // 作答次數 超過 設定值
                if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) === 1)
                {
                    // 作答次數 超過 一次
                    console.log("Reach one time submission limit")
                    strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededOnce
                    blnEnablePractice = false
                }
                else
                {
                    // 作答次數 超過 兩次
                    console.log("Reach two times submission limit")
                    strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededTwice
                    blnEnablePractice = false
                }
            }

            mblnPracticeEnable = blnEnablePractice
            mstrPracticeDisableMessage = strMsg
            console.log("mblnPracticeEnable: ", mblnPracticeEnable)
            console.log("mstrPracticeDisableMessage: ", mstrPracticeDisableMessage)
            setPracticeEnable(mblnPracticeEnable)
        }
        else
        {
            // 身份為 老師 或 個人 則不會有限制是否可Practice
            mblnPracticeEnable = true
            setPracticeEnable(mblnPracticeEnable)
        }
    }

    function RegisterExecuteCompositionMainAction()
    {
        let objCallbackData = {
            "Action": "RegisterExecuteCompositionMainAction",
            "Function": ExecuteCompositionMainAction
        }

        props.CallbackRef(objCallbackData)
    }

    function ExecuteCompositionMainAction(Action)
    {
        console.log(COMP_NAME + ".ExecuteCompositionMainAction Action: ", Action)

        switch (Action)
        {
            case ExecuteActionEnum.RegisterAudioEvent:
                mfuncExecuteCompositionContentAction(ExecuteActionEnum.RegisterAudioEvent)
                break
            default:
                break
        }
    }

    /*===========================================
    summary: 註冊 語言改變事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function RegisterLanguageChangeHandler()
    {
        // console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler BEGIN")

        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    } // end of RegisterLanguageChangeHandler
    // #endregion Other Functions

    function SaveAnswer()
    {
        console.log(COMP_NAME + ".SaveAnswer: ")

        let intAction = ExecuteActionEnum.SaveAnswer
        mfuncExecuteCompositionContentAction(intAction)
        SetTestSheetContextNotDirtyForLearningUnit()
    }

    function GetPrerequisiteDataProcessBegin()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessBegin: ")

        // 2 Steps:
        // 1. History
        // 2. Temp Answer List
        GetAssignmentAssignAnswer()
    }

    function GetPrerequisiteDataProcessEnd()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessEnd: ")

        console.log("mobjLUCacheContext.AssigementHistoryList: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])
        console.log("mobjLUCacheContext.AssignmentTempAnsList: ", mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext])

        let enumTestSheeMode = TestSheetModeEnum.New
        if (
            (mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] !== null) &&
            (mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].TestedTime !== null)
        )
        {
            enumTestSheeMode = TestSheetModeEnum.Temp
        }
        else if (
            (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] !== null) &&
            (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length > 0)
        )
        {
            enumTestSheeMode = TestSheetModeEnum.History
            mintIndex4HistoryItemToShow = 0
        }

        // enumTestSheeMode = TestSheetModeEnum.History // TEST
        CheckPraceticeEnable()
        console.log("enumTestSheeMode: ", enumTestSheeMode)
        SetTestSheetObject(enumTestSheeMode)
    }

    function SetTestSheetObject(TestSheetMode)
    {
        console.log(COMP_NAME + ".SetTestSheetObject: ", TestSheetMode)
        console.log("mobjLUCacheContext.AssigementHistoryList: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])
        console.log("mobjLUCacheContext.AssignmentTempAnsList: ", mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext])

        // mintCurrentSentenceIndex = 0 // Temp 的話要看第一筆 -1 的
        mobjTestSheet.Mode = TestSheetMode
        mobjTestSheet.Score = -1
        mobjTestSheet.Dirty = false
        mobjTestSheet.AnswerList = []
        mobjTestSheet.AssignID = -1
        let arrTempAnswerList = []
        let objHistoryAnswerSheet = null
        let arrHistoryAnswerList = []
        if (TestSheetMode === TestSheetModeEnum.Temp)
        {
            arrTempAnswerList = mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].AnswerList
        }
        else if (TestSheetMode === TestSheetModeEnum.History)
        {
            console.log("mintIndex4HistoryItemToShow: ", mintIndex4HistoryItemToShow)
            objHistoryAnswerSheet = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList[mintIndex4HistoryItemToShow]
            arrHistoryAnswerList = objHistoryAnswerSheet.AnswerList

            mobjTestSheet.AssignID = objHistoryAnswerSheet.AssignID
            // mobjTestSheet.Cached = objHistoryAnswerSheet.Cached
            if (objHistoryAnswerSheet.Score !== null)
            {
                mobjTestSheet.Score = parseFloat(objHistoryAnswerSheet.Score)
            }
            else
            {
                mobjTestSheet.Score = null
            }
        }

        let i = 0;
        let intCount = props.LUInfo.SuperQuestion.length
        for (i = 0; i < intCount; i++)
        {
            let objAnswer = null
            if (TestSheetMode === TestSheetModeEnum.Temp)
            {
                let objTempAnswer = arrTempAnswerList[i]
                console.log("objTempAnswer: ", objTempAnswer)

                // "SQSeqNo": "8",
                // "CompositionAns": null,
                // "RecordedAnsFN": null,
                // "ImageAns01FN": "ImgAns01_11412_8__459.jpg",
                // "ImageAns02FN": null,
                // "ImageAns03FN": null,
                // "TeacherFeedbackAudioFN": null,
                // "TeacherFeedbackText": null,
                // "TeacherFeedbackVideoFN": null
                // let strAudioUrl = null
                // let strImage01Url = null
                // let strImage02Url = null
                // let strImage03Url = null

                objAnswer = {
                    AnswerID: objTempAnswer.AnswerID,
                    SQSeqNo: objTempAnswer.SQSeqNo,
                    CompositionAns: objTempAnswer.CompositionAns,
                    RecordedAnsFN: objTempAnswer.RecordedAnsFN,
                    ImageAns01FN: objTempAnswer.ImageAns01FN,
                    ImageAns02FN: objTempAnswer.ImageAns02FN,
                    ImageAns03FN: objTempAnswer.ImageAns03FN,
                    TeacherFeedbackAudioFN: objTempAnswer.TeacherFeedbackAudioFN,
                    TeacherFeedbackText: objTempAnswer.TeacherFeedbackText,
                    TeacherFeedbackVideoFN: objTempAnswer.TeacherFeedbackVideoFN
                }

                console.log("objAnswer: ", objAnswer)
            }
            else if (TestSheetMode === TestSheetModeEnum.History)
            {
                let objTempAnswer = arrHistoryAnswerList[i]
                console.log("objTempAnswer: ", objTempAnswer)

                objAnswer = {
                    AnswerID: objTempAnswer.AnswerID,
                    SQSeqNo: objTempAnswer.SQSeqNo,
                    CompositionAns: objTempAnswer.CompositionAns,
                    RecordedAnsFN: objTempAnswer.RecordedAnsFN,
                    ImageAns01FN: objTempAnswer.ImageAns01FN,
                    ImageAns02FN: objTempAnswer.ImageAns02FN,
                    ImageAns03FN: objTempAnswer.ImageAns03FN,
                    TeacherFeedbackAudioFN: objTempAnswer.TeacherFeedbackAudioFN,
                    TeacherFeedbackText: objTempAnswer.TeacherFeedbackText,
                    TeacherFeedbackVideoFN: objTempAnswer.TeacherFeedbackVideoFN
                }

                console.log("objAnswer: ", objAnswer)

            }
            else if (TestSheetMode === TestSheetModeEnum.New)
            {
                let strSQSeqNo = props.LUInfo.SuperQuestion[i].SQSeqNo
                objAnswer = {
                    AnswerID: null,
                    SQSeqNo: strSQSeqNo,
                    CompositionAns: null,
                    RecordedAnsFN: null,
                    ImageAns01FN: null,
                    ImageAns02FN: null,
                    ImageAns03FN: null,
                    TeacherFeedbackAudioFN: null,
                    TeacherFeedbackText: null,
                    TeacherFeedbackVideoFN: null
                }
            }
            mobjTestSheet.AnswerList.push(objAnswer)
        }
        console.log("mobjTestSheet: ", mobjTestSheet)

        setUpdateDataTime(new Date().getTime())
    }

    function GetTextYourScore()
    {
        console.log(COMP_NAME + ".GetTextYourScore: ")
        let strScore = window.gAppUI.LBL_NotScore
        if (mobjTestSheet.Mode === TestSheetModeEnum.History)
        {
            if (
                (typeof (mobjTestSheet.Score) !== "undefined") &&
                (mobjTestSheet.Score !== null)
            )
            {
                strScore = mobjTestSheet.Score.toString()
            }
        }
        return strScore
    }
    // #endregion Other Functions

    // #region Get ClassName and Style
    /*===========================================
    summary: 取得 學生做答按鈕 Cls
    remarks: 000 Tim 2021/12/09 Create
    ===========================================*/
    function GetContentCls(LUCatSeqNo)
    {
        let objCls = cssCompositionMain.divContent

        if (
            (parseInt(LUCatSeqNo) === window.gDCPLUEnum.PracticeWritingComposition) ||
            (parseInt(LUCatSeqNo) === window.gDCPLUEnum.ReviewWritingComposition)
        )
        {
            objCls = cssCompositionMain.divContent4WritingComposition
        }

        return objCls
    } // end of GetContentCls

    function GetClsButtonRetry(PracticeEnable)
    {
        console.log(COMP_NAME + ".GetClsButtonRetry: ", mobjTestSheet, PracticeEnable)
        let objCls = null

        if (mobjTestSheet.Mode === TestSheetModeEnum.History)
        {
            if (PracticeEnable)
            {
                objCls = cssCompositionMain.divTitleRightButtonArea
            }
            else
            {
                objCls = cssCompositionMain.divTitleRightButtonAreaDisable
            }
        }
        else
        {
            objCls = cssCompositionMain.divHidden
        }

        return objCls
    }

    function GetClsButtonSubmit(PracticeEnable)
    {
        console.log(COMP_NAME + ".GetClsButtonSubmit: ", mobjTestSheet, PracticeEnable)

        console.log("mobjTestSheet.Mode:", mobjTestSheet.Mode)
        let objCls = null

        if (mobjTestSheet.Mode === TestSheetModeEnum.History)
        {
            objCls = cssCompositionMain.divHidden
        }
        else if (
            (mobjTestSheet.Mode === TestSheetModeEnum.Temp) ||
            mobjTestSheet.Dirty
        )
        {
            if (PracticeEnable)
            {
                objCls = cssCompositionMain.divTitleRightButtonArea
            }
            else
            {
                objCls = cssCompositionMain.divTitleRightButtonAreaDisable
            }

        }
        else if (mobjTestSheet.Mode === TestSheetModeEnum.New)
        {
            objCls = cssCompositionMain.divTitleRightButtonAreaDisable
        }
        return objCls
    }

    function GetClsButtonHistory(AssignmentTempAns, AssigementHistoryItem)
    {
        console.log(COMP_NAME + ".GetClsButtonHistory: ")
        let objCls = cssCompositionMain.divTitleRightButtonAreaDisable
        if (
            (
                (typeof (AssignmentTempAns) !== "undefined") &&
                (AssignmentTempAns !== null) &&
                (typeof (AssignmentTempAns.TestedTime) !== "undefined") &&
                (AssignmentTempAns.TestedTime !== null)
            ) // 有 部分完成的答案
            ||
            (
                (typeof (AssigementHistoryItem) !== "undefined") &&
                (AssigementHistoryItem !== null) &&
                (typeof (AssigementHistoryItem.NewAssignList) !== "undefined") &&
                (AssigementHistoryItem.NewAssignList.length > 0)
            ) // 有 答題完成的歷史答案
        )
        {
            objCls = cssCompositionMain.divTitleRightButtonArea
        }
        return objCls
    }

    function GetClsBarOnTheLeftOfSave(TestSheetMode)
    {
        console.log(COMP_NAME + ".GetClsBarOnTheLeftOfSave: ", mobjTestSheet)
        let objCls = null
        if (TestSheetMode === TestSheetModeEnum.History)
        {
            objCls = cssCompositionMain.divHidden
        }
        else
        {
            objCls = cssCompositionMain.divTitleRightBar
        }
        return objCls
    }

    function GetClsButtonSave()
    {
        console.log(COMP_NAME + ".GetClsButtonSave: ", mobjTestSheet)
        let objCls = null

        if (mobjTestSheet.Mode === TestSheetModeEnum.History)
        {
            objCls = cssCompositionMain.divHidden
        }
        else if (
            (mobjTestSheet.Mode === TestSheetModeEnum.New) ||
            (mobjTestSheet.Mode === TestSheetModeEnum.Temp)
        )
        {
            if (mobjTestSheet.Dirty)
            {
                objCls = cssCompositionMain.divTitleRightButtonArea
            }
            else
            {
                objCls = cssCompositionMain.divTitleRightButtonAreaDisable
            }
        }
        return objCls
    }
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    function GetAssignmentAssignAnswerAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswerAfterProcess: ", ReturnData)

        // 更新 Cache
        mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] = ReturnData

        console.log("完成 Step 1, 需進行 Step 2")

        // 取得 Temp Answer List
        GetNewAssignmentAssignTmpAnswer()
    } // end of GetAssignmentAssignAnswerAfterProcess

    function GetNewAssignmentAssignTmpAnswerAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignTmpAnswerAfterProcess: ", ReturnData)

        console.log("mobjLUCacheContext: ", mobjLUCacheContext)
        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] = ReturnData

        GetPrerequisiteDataProcessEnd()
    } // end of GetNewAssignmentAssignTmpAnswerAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    function GetAssignmentAssignAnswer()
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswer: ", props.LUInfo.LUCatSeqNo)

        let objRetryFuncRef = GetAssignmentAssignAnswer
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAssignmentAssignAnswerCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAssignmentAssignAnswer)

            // Func: "GetNewAssignmentAssignAnswer"
            // AssignID: -1
            // Assignee: 459
            // BookCategoryID: "03"
            // LUCatSeqNo: 14
            // LessonID: "03001"

            let objCallData = {
                "Func": "GetNewAssignmentAssignAnswer",
                "Assignee": window.gSession.Acc.ID,
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "AssignID": -1
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                }
                )
        }
    }

    function GetAssignmentAssignAnswerCallback(Return)
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswerCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAssignmentAssignAnswer_No
        let strErrorTitle = window.gAppUI.ERR_GetAssignmentAssignAnswer_Title
        let strErrMsg = window.gAppUI.ERR_GetAssignmentAssignAnswer_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetAssignmentAssignAnswerCallback: ErrNo: ", Return.ErrNo)
            console.log("GetAssignmentAssignAnswerCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetAssignmentAssignAnswerCallback Return.Data", Return.Data)

            GetAssignmentAssignAnswerAfterProcess(Return.Data)
        }
    }

    function GetNewAssignmentAssignTmpAnswer()
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignTmpAnswer: ")
        let objRetryFuncRef = GetNewAssignmentAssignTmpAnswer
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Title, window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetNewAssignmentAssignTmpAnswerCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetNewAssignmentAssignTmpAnswer)

            // Func: "GetNewAssignmentAssignAnswer"
            // AssignID: -1
            // Assignee: 459
            // BookCategoryID: "03"
            // LUCatSeqNo: 11
            // LessonID: "03001"

            let objCallData = {
                "Func": "GetNewAssignmentAssignTmpAnswer",
                "Assignee": window.gSession.Acc.ID,
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "AssignID": -1
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                }
                )
        }
    }

    function GetNewAssignmentAssignTmpAnswerCallback(Return)
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignTmpAnswerCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_No
        let strErrorTitle = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Title
        let strErrMsg = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Msg


        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetNewAssignmentAssignTmpAnswerCallback: ErrNo: ", Return.ErrNo)
            console.log("GetNewAssignmentAssignTmpAnswerCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetNewAssignmentAssignTmpAnswerCallback Return.Data", Return.Data)
            GetNewAssignmentAssignTmpAnswerAfterProcess(Return.Data)
        }
    }
    // #endregion Web Service

    // #region Component
    // #endregion Component

    // #region Render

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if (intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssCompositionMain.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }

        return objBlockGoogleClassroomButton
    }

    function RenderHeaderLeftArea()
    {
        let strTitleEN = props.SubSectionDef.Name
        let strTitleCN = ""
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName
        }

        return (
            <>
                <div className={cssCompositionMain.divTitleLeftArea}>
                    {RenderGoogleClassrommButton()}
                    <div className={cssCompositionMain.divTitleSubArea}>
                        <div className={cssCompositionMain.divLessonIcon}></div>
                        <div className={cssCompositionMain.divLUTitleTextEN}>
                            {strTitleEN}
                        </div>
                        <div className={cssCompositionMain.divDividerBar}></div>
                        <div className={cssCompositionMain.divLUTitleTextCN}>
                            {strTitleCN}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    function RenderHeaderRightSubBottomArea()
    {
        console.log(COMP_NAME + ".RenderHeaderRightSubBottomArea: ")

        return (
            <div className={cssCompositionMain.divTitleRightSubBottomArea}>
                <div className={cssCompositionMain.divScoreTitle}>
                    {window.gAppUI.LBL_YourScore}:
                </div>
                <div className={cssCompositionMain.divTitleRightScore}>
                    {GetTextYourScore()}
                </div>

                <div className={cssCompositionMain.divTitleRightBar}></div>

                <div className={GetClsButtonHistory(mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext], mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])} onClick={() => HistoryOnTapHandler()}>
                    <div className={cssCompositionMain.divIconHistory}></div>
                    <div className={cssCompositionMain.divTitleButtonText}>
                        {window.gAppUI.BTN_History}
                    </div>
                </div>

                <div className={GetClsBarOnTheLeftOfSave(mobjTestSheet.Mode)}></div>

                <div className={GetClsButtonSave()} onClick={() => SaveOnTapHandler()}>
                    <div className={cssCompositionMain.divIconSave}></div>
                    <div className={cssCompositionMain.divTitleButtonText}>
                        {window.gAppUI.BTN_Save}
                    </div>
                </div>
                <div className={cssCompositionMain.divTitleRightBar}></div>
                <div className={GetClsButtonRetry(mblnPracticeEnable)} onClick={() => RetryOnTapHandler()}>
                    <div className={cssCompositionMain.divIconRetry}></div>
                    <div className={cssCompositionMain.divTitleButtonText}>
                        {PackageVariablesLibs.UISettings.BTN_Retry}
                    </div>
                </div>
                <div className={GetClsButtonSubmit(mblnPracticeEnable)} onClick={() => SubmitOnTapHandler()}>
                    <div className={cssCompositionMain.divIconSubmit}></div>
                    <div className={cssCompositionMain.divTitleButtonText}>
                        {window.gAppUI.BTN_Submit}
                    </div>
                </div>
            </div>
        )
    }

    /*===========================================
    summary: Render Header SubSubSection Tool 的顯示
    remarks: 000 Tim 2021/12/30 Create
    ===========================================*/
    function RenderHeaderSubSubSectionToolArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderSubSubSectionToolArea props.SubSectionDef: ", props.SubSectionDef)
        // props.SubSectionDef:  
        // SubSubSection: Array(2)
        // 0: {SubSubSectionSeqNo: '06', Name: 'Grammar Exercises', MajorName: '句型练习', MinorName: '句型練習', LUCatSeqNo: '26'}
        // 1: {SubSubSectionSeqNo: '07', Name: 'Composition', MajorName: '写一写', MinorName: '寫一寫', LUCatSeqNo: '18'}

        return (
            <div className={cssCompositionMain.divSubSubSectionToolArea}>
                <div className={cssCompositionMain.btnSubSubSection} onClick={() => SubSubSectionOnTapHandler()}>
                    {props.SubSectionDef.SubSubSection[0].Name}
                </div>
                <div className={cssCompositionMain.btnSubSubSectionDisalbed}>
                    {props.SubSectionDef.SubSubSection[1].Name}
                </div>
            </div>
        )
    } // end of RenderHeaderSubSubSectionToolArea                    

    function RenderHeaderRightArea()
    {
        if (
            (parseInt(props.LUInfo.LUCatSeqNo) !== window.gDCPLUEnum.PracticeWritingComposition) &&
            (parseInt(props.LUInfo.LUCatSeqNo) !== window.gDCPLUEnum.ReviewWritingComposition)
        )
        {
            return (
                <div className={cssCompositionMain.divTitleRightArea}>
                    {RenderHeaderRightSubBottomArea()}
                </div>
            )
        }
        else
        {
            // 練習 寫一寫        LUSeqNo: 18
            // 複習 寫一寫        LUSeqNo: 22

            return (
                <div className={cssCompositionMain.divTitleRightArea}>
                    {RenderHeaderSubSubSectionToolArea()}
                    {RenderHeaderRightSubBottomArea()}
                </div>
            )
        }
    }

    function RenderHeader()
    {
        // console.log(COMP_NAME + ".RenderHeader")
        return (
            <>
                {RenderHeaderRightArea()}
                {RenderHeaderLeftArea()}
            </>
        )
    }

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/29 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <TestSheetContext.Provider value={mobjTestSheet}>
                    <div className={GetContentCls(props.LUInfo.LUCatSeqNo)}>
                        <CompositionContent LUInfo={props.LUInfo}
                            LessonID={props.LessonID}
                            SubSectionDef={props.SubSectionDef}
                            GoToLUSinceAction={props.GoToLUSinceAction}
                            UpdateDataTime={StateUpdateDataTime}
                            Index4HistoryItemToShow={mintIndex4HistoryItemToShow}
                            PracticeEnable={practiceEnable}
                            CallbackRef={ComponentCallback} />
                    </div>
                </TestSheetContext.Provider>
            )
        }
    } // end of RenderContentWrapper

    // 不允許編輯的動畫文字
    function RenderAnimationMessageAreaForPracticeDisable(StatePracticeEnable)
    {
        console.log(COMP_NAME + ".RenderAnimationMessageAreaForPracticeDisable: ")
        let objBlock = null
        if (!StatePracticeEnable)
        {
            objBlock = (
                <div className={cssCompositionMain.divAnimationMessageAreaForPracticeDisable}>
                    {mstrPracticeDisableMessage}
                </div>
            )
        }
        return objBlock
    }


    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/29 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                {RenderHeader()}
                {RenderContentWrapper(updateDataTime)}
                {RenderAnimationMessageAreaForPracticeDisable(practiceEnable)}
            </>
        )
    } // end of RenderMainWrapper

    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default CompositionMain